import request from '../../../api/request';

export async function getMassiveAdmissionCallTemplate() {
  return await request(
    `maintainers-portal/admission-management/study-plan-version-offers/massive-admission-call/template`,
    {
      responseType: 'blob',
    },
  );
}
